export const MIN_EXPORT_YYYYMM = '202310'
export const MIN_EXPORT_YEAR = 2023
export const MIN_EXPORT_MONTH_INDEX = 9

export const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const

export interface ExportMonthParams {
  year: number
  month: number
}

export function parseExportYyyymm(yyyymm: string): ExportMonthParams | null {
  if (yyyymm.length !== 6) {
    return null
  }

  const year = Number.parseInt(yyyymm.slice(0, 4), 10)
  const month = Number.parseInt(yyyymm.slice(4), 10)

  if (!Number.isInteger(year) || year < MIN_EXPORT_YEAR) {
    return null
  }

  if (!Number.isInteger(month) || month < 1 || month > 12) {
    return null
  }

  return { year, month }
}

export function isValidExportYyyymm(yyyymm: string): boolean {
  return parseExportYyyymm(yyyymm) !== null && yyyymm >= MIN_EXPORT_YYYYMM
}

export function isBeforeMinExportMonth(year: number, monthIndex: number): boolean {
  return year < MIN_EXPORT_YEAR || (year === MIN_EXPORT_YEAR && monthIndex < MIN_EXPORT_MONTH_INDEX)
}

export function formatMonthLabel(year: number, monthIndex: number): string {
  return `${MONTH_NAMES[monthIndex]} ${year}`
}

export function toYyyymm(year: number, monthIndex: number): string {
  return `${year}${String(monthIndex + 1).padStart(2, '0')}`
}

export function getDefaultYyyymm(): string {
  const today = new Date()
  return toYyyymm(today.getFullYear(), today.getMonth())
}
